module.exports = __webpack_public_path__ + "assets/ALIBABAFont-75bab6fc.svg";